import { Navigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "../constants/routes";

const Register = () => {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  params.set("tab", "register");

  return <Navigate to={`${ROUTES.login}?${params.toString()}`} replace />;
};

export default Register;
